// export const url = "http://192.168.24.2/birs-back/";
export const url = "https://rhm.irs.kg.gov.ng/mobile/birs-back/";
